import React from 'react'
import SidebarLayout from '../components/SidebarLayout'

import TotalPlansWidget from '../components/widgets/TotalPlansWidget'
import PlansThisWeekWidget from '../components/widgets/PlansThisWeekWidget'
import LatestUploadedPlans from '../components/widgets/LatestUploadedPlans'

import VerifiedPlansWidget from '../components/widgets/VerifiedPlansWidget'
import PlansVerifiedThisWeekWidget from '../components/widgets/PlansVerifiedThisWeekWidget'
import AnnouncementsWidget from '../components/widgets/AnnouncementsWidget'

import RiqInteractionsWidget from '../components/widgets/RiqInteractionsWidget'
import RiqAccuracyWidget from '../components/widgets/RiqAccuracyWidget'
import AskRiqCtaWidget from '../components/widgets/AskRiqCtaWidget'

function DashboardPage() {
  return (
    <SidebarLayout>
      <div
        style={{
          backgroundColor: '#f1f5f9',
          padding: '1rem 1.25rem',
          borderBottom: '1px solid #e2e8f0',
          fontSize: '1.125rem',
          fontWeight: 600,
          color: '#0f172a',
          borderTopLeftRadius: '0.5rem',
          borderTopRightRadius: '0.5rem',
          textAlign: 'center',
        }}
      >
        CuvrIQ Dashboard
      </div>

      <div
        className="dashboard-grid"
        style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        border: '1px solid #e5e7eb',
        borderRight: 'none',
        borderBottom: 'none',
        width: '100%',
        }}
      >

        <TotalPlansWidget />
        <PlansThisWeekWidget />
        <LatestUploadedPlans />
        <VerifiedPlansWidget />
        <PlansVerifiedThisWeekWidget />
        <AnnouncementsWidget />
        <RiqInteractionsWidget />
        <RiqAccuracyWidget />
        <AskRiqCtaWidget />
      </div>
    </SidebarLayout>
  )
}

export default DashboardPage
